import { Box } from '@mui/material';
import {
  StyledWidgetGlobalPrice,
  IconContainer,
  Label,
  NumberContainer,
  Number,
  NumberIcon
} from './WidgetGlobalPrice.styles'

import WidgetGlobalPriceSkeleton from './Skeletons/WidgetGlobalPriceSkeleton'

const WidgetGlobalPrice = ({ data, icon, loading = false }) => {
  if (loading) return <WidgetGlobalPriceSkeleton />;

  return (
    <StyledWidgetGlobalPrice sx={{ flexDirection: 'column', gap: 2 }}>
      <IconContainer sx={{ mb: 0 }}>
        <i className={icon} />
      </IconContainer>
      <Box textAlign="start" sx={{ display: 'flex', flexDirection: { xs: 'row', lg: 'column' }, gap: 2, flexWrap: 'wrap', justifyContent: 'center', alignItems: { xs: 'center', lg: 'flex-start' } }}>
        {data.map(({ label, number, textIcon }, index) => {
          return (
            <Box key={index} textAlign="start">
              <Label>{label}</Label>
              <NumberContainer>
                <Number>{number}</Number>
                <NumberIcon>
                  {textIcon && <span>{textIcon}</span>}
                </NumberIcon>
              </NumberContainer>
            </Box>
          );
        })}
      </Box>
    </StyledWidgetGlobalPrice>
  );
};

export default WidgetGlobalPrice;
